import styled from "@emotion/styled";
import Menu from "@mui/material/Menu";
import { COLOR_GREY_5 } from "shared/theme/colors";

export const StyledMenu = styled(Menu)`
  & .MuiMenu-paper {
    font-weight: 400;
    width: auto;
    min-width: 170px;
    border-radius: 0.75rem;

    .MuiList-root {
      padding: 0.5rem 0;

      .MuiMenuItem-root {
        height: 32px;
        padding: 0.5rem 0.75rem;
        border-radius: 0.25rem;

        :hover.remove {
          background-color: rgba(244, 67, 54, 0.08);
        }

        & + .MuiDivider-root {
          margin: 0.25rem 0;
          border-color: ${COLOR_GREY_5};
        }
      }
    }
  }
`;
